/** @format */

import React, { useState } from "react";
import commonStyle from "../common.module.scss";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { t } from "i18next"

const OrdersSectionItemCreate = ({ onSubmit, onSubmitDraft, isLoading }) => {
  const clickHandle = () => {
    if (onSubmit) onSubmit();
  };

  return (
    <>
      <div className={commonStyle.createContainer}>
        <CustomButton
          text={t('saveToDraft')}
          isMain
          onClick={onSubmitDraft}
          isUnderline
          isBlackText
        />
        <CustomButton
          text={t('publishOrder')}
          isMain
          onClick={clickHandle}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default OrdersSectionItemCreate;
